import { gql } from '@apollo/client';

export const UpdatePaymentMethod = gql`
mutation UpdatePaymentMethod($updatePaymentMethodId: ID!, $content: contentPaymentMethod!) {
  updatePaymentMethod(id: $updatePaymentMethodId, content: $content) {
    status
  }
}
`;